var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1345 3.16525C2.157 2.944 2.07225 2.72575 1.90725 2.57725L0.22725 0.55225V0.25H5.44575L9.47925 9.09625L13.0253 0.25H18V0.55225L16.563 1.93C16.4392 2.0245 16.3778 2.17975 16.4032 2.3335V12.457C16.3778 12.61 16.4392 12.7653 16.563 12.8597L17.9662 14.2375V14.5397H10.9073V14.2375L12.3615 12.826C12.504 12.6835 12.504 12.6415 12.504 12.4233V4.24075L8.46225 14.5068H7.91625L3.21 4.24075V11.1213C3.171 11.41 3.267 11.7018 3.47025 11.9103L5.361 14.2037V14.5068H0V14.2037L1.89075 11.9103C2.09325 11.701 2.18325 11.4078 2.1345 11.1213V3.16525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumIcon);
export default __webpack_public_path__ + "static/media/medium-icon.edec970c496dd0291b9c70c1d6f5c00d.svg";
export { ForwardRef as ReactComponent };